import regexp from '@/common/regexp';

/**
 * Converts "DEPENDENT_CARE" → "Dependent care"
 */
export const formatCategoryType = (value: string): string =>
  value
    .replace(regexp.DASH_SYMBOL, ' ')
    .toLowerCase()
    .replace(regexp.FIRST_LETTER, (char) => char.toUpperCase());

/**
 * Converts "Dependent care" → "DEPENDENT_CARE"
 */
export const toCategoryTypeKey = (value: string): string =>
  value.replace(regexp.SPACE_SYMBOL, '_').toUpperCase();
